import React, { PureComponent, FunctionComponent } from "react";
import { PERMISSION_MESSAGE, REPERTOIRE_PAGE_FORM_ACTION_BUTTON_SIZE, REPERTOIRE_PAGE_FORM_ITEM_SIZE } from "../../Consts";
import ITooltip from "../Tooltip/IToolTip";

export interface IActionButtonProps {
    buttonText: string;
    buttonAction: () => void;
    disabled?: boolean;
    dataTestId?: string;
    className?: string;
    showTooltip?: boolean;
    type?: "button" | "submit" | "reset";
}

export interface IActionButtonFormikProps {
    buttonText: string;
    disabled?: boolean;
    className?: string;
    isSubmitting: boolean;
    isErrorInForm: boolean;
    showTooltip?: boolean;
}

export const SizedActionButton: FunctionComponent<IActionButtonProps> = (props: IActionButtonProps) => {
    return <div className={REPERTOIRE_PAGE_FORM_ACTION_BUTTON_SIZE}>
        <ActionButton {...props} />
    </div>
}

export const WideActionButton: FunctionComponent<IActionButtonProps> = (props: IActionButtonProps) => {
    return <div className={REPERTOIRE_PAGE_FORM_ITEM_SIZE}>
        <ActionButton {...props} />
    </div>
}

export const InlineActionButton: FunctionComponent<IActionButtonProps> = (props: IActionButtonProps) => {
    return <ActionButton {...props} />
}

export default class ActionButton extends PureComponent<IActionButtonProps> {
    render() {
        const { buttonText, buttonAction, disabled, className, dataTestId, showTooltip } = this.props;


        return (
            <ITooltip
                tooltipContent={PERMISSION_MESSAGE}
                showTooltip={showTooltip}
            >
                <button
                    type={this.props.type ?? "submit"}
                    onClick={!showTooltip ? buttonAction : undefined}
                    className={className ?? "button btn-defaultPrimary"}
                    disabled={disabled || showTooltip}
                    data-testid={
                        dataTestId
                            ? `${buttonText}-${dataTestId}-action-button`
                            : `${buttonText}-action-button`
                    }
                >
                    {buttonText}
                </button>
            </ITooltip>

        );
    }
}

export class ActionButtonFormik extends PureComponent<IActionButtonFormikProps> {
    handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        const { showTooltip } = this.props;
        if (showTooltip) {
            e.preventDefault(); // prevent form submission
        }
    };
    render() {
        const {
            buttonText,
            className,
            isSubmitting,
            isErrorInForm,
            disabled,
            showTooltip,
        } = this.props;

        const isDisabled = isSubmitting || isErrorInForm || disabled || showTooltip;

        const button = (
            <button
                type="submit"
                onClick={this.handleClick}
                disabled={isDisabled || showTooltip}
                className={className ?? "button btn-defaultPrimary"}
                data-testid={buttonText + "-action-button"}
            >
                {buttonText}
            </button>
        );

        return showTooltip ? (
            <ITooltip tooltipContent={PERMISSION_MESSAGE} showTooltip={showTooltip}>
                <div>{button}</div>
            </ITooltip>
        ) : button;
    }
}
